import i18n from '@src/i18n';

import { APP_NAME } from './constants';

export function getLocalizedTitle(
  key: string,
  defaultValue: string,
): string {
  const pageTitle = String(i18n.t(key, { defaultValue }));
  return `${pageTitle} | ${APP_NAME}`;
}

export function getLocalizedDynamicTitle(
  key: string,
  defaultValue: string,
  suffix: string,
): string {
  const pageTitle = String(i18n.t(key, { defaultValue }));
  const normalizedSuffix = suffix.trim();

  if (!normalizedSuffix) {
    return `${pageTitle} | ${APP_NAME}`;
  }

  return `${pageTitle}: ${normalizedSuffix} | ${APP_NAME}`;
}
